export const mapUpdate = (favorites: string[]) => favorites.map((itemCode) => ({ itemCode }));
